import React from "react";
import styles from "./please-wait-while-processing.module.scss";
import { useI18N } from "@src/language/language-context";
import Spinner from "@src/components/atoms/spinner/spinner";

const cssClassName = "please-wait-while-processing";

export const PleaseWaitWhileProcessing = () => {
  const i18n = useI18N();

  const texts = {
    info: i18n("modules.pleaseWaitWhileProcessing.info"),
  };

  return (
    <div className={styles[cssClassName]}>
      <Spinner />
      <div style={{ marginTop: "16px" }}>{texts.info}</div>
    </div>
  );
};
